import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { AnimatePresence, motion } from "framer-motion";
import useWindowWidth from "../../config/useWindowWidth";
import Head from "../Head";
import "../../sass/DirectOrder.scss";

const variants = {
  enter: (): object => {
    return {
      opacity: 0,
    };
  },
  center: (): object => {
    return {
      opacity: 1,
    };
  },
  exit: () => {
    return {
      opacity: 0,
    };
  },
};

export default function MyCollectionContent2() {
  const width = useWindowWidth();
  return false ? (
    <div className="loading_orders">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : width <= 575 ? (
    <AnimatePresence exitBeforeEnter={false}>
      <div className="row direct_order">
        {!false && (
          <motion.div
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            className="col-xs-12 col-sm-3 col-md-3 p-0 order_list_side"
          >
            full
          </motion.div>
        )}
      </div>
    </AnimatePresence>
  ) : (
    <AnimatePresence exitBeforeEnter={false}>
      <Head title="Direct Orders" />
      <div className="row direct_order">
        <div className="col-xs-12 col-sm-3 col-md-3 p-0 order_list_side">
          left
        </div>

        <motion.div
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          className="col-9 p-0 order_details_container"
        >
          right
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
